<template>
  <div>
    <center>

    </center>
    <div style="float: left;margin-left: 100px">
<!--      <router-link to="/reportTools/customQuery" style="color: darkblue">-->
<!--        上一步-->
<!--      </router-link>-->
      <el-button type="primary"  v-on:click="tocustomQuery" >上一步</el-button>
    </div>
    <div style="float: right;margin-right: 100px">
      <el-button type="primary"  v-on:click="saveResource" >保存</el-button>
    </div>
        <br>
        <h1>基本信息设置</h1>
    <br>
    <br>
    <center>
    <div style="margin-right: 170px">
  <el-form ref="form" :model="form" label-width="120px" >
    <el-form-item label="报表名称中文:" style="width: 470px;">
      <el-input v-model="form.reportName" ></el-input>
    </el-form-item>
    <el-form-item label="报表名称英文:" style="width: 470px;">
      <el-input v-model="form.reportEnName"></el-input>
    </el-form-item>
    <el-form-item label="报表名称中英文:" style="width: 470px;">
      <el-input v-model="form.reportChEnName"></el-input>
    </el-form-item>
    <el-form-item label="报表备注:" style="width: 470px;">
      <el-input v-model="form.remarks"></el-input>
    </el-form-item>
    <el-form-item label="功能编号" style="width: 470px;">
      <el-input v-model="form.code" ></el-input>
    </el-form-item>
    <el-form-item label="编辑模板:" style="width: 570px;">
      <el-input placeholder="模板地址" style="width: 200px" disabled></el-input>
      <el-upload class="upload-demo"
                 :action="uploadUrl"
                 :before-upload="handleBeforeUpload"
                 :on-error="handleUploadError"
                 :before-remove="beforeRemove"
                 multiple
                 :limit="5"
                 :on-exceed="handleExceed"
                 :file-list="fileList">
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
      <a href="file/download?fileName=test.xls">下载附件</a>
    </el-form-item>
    <el-form-item label="模板备注:"  style="width: 480px;">
      模板用于下载，打印EXCEL时使用。其中&#123;&nbsp;{CURRENT_USER&#125;&nbsp;&#125;表示当前用户名，
      &#123;&nbsp;{TITLE&#125;&nbsp;&#125;表示表头，&#123;&nbsp;{DATA&#125;&nbsp;&#125;表示数据行，&#123;&nbsp;{FOOTER&#125;&nbsp;&#125;表示页脚区域。
      导出的内容不可改动，页眉页脚区域可以自由编辑。
    </el-form-item>
    <el-form-item >
      <el-select v-model="form.isPublic" style="width: 350px;">
        <el-option label="私有查询" value="2" ></el-option>
        <el-option label="公共查询" value="1"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item >
        <el-checkbox label="是否打印" v-model="form.isPrinting" true-label="1" false-label="2"></el-checkbox>
        <el-checkbox label="是否导出" v-model="form.isExport" true-label="1" false-label="2"></el-checkbox>
      <el-form-item  type="hidden" style="width: 470px;">
<!--        <el-input v-model="datas[0][datas[0].name]" type="hidden" ></el-input>-->
<!--        <el-input v-model="datas[1][datas[1].name]" type="hidden" ></el-input>-->
<!--        <el-input v-model="datas[2][datas[2].name]" type="hidden" ></el-input>-->
<!--        <el-input v-model="datas[3][datas[3].name]" type="hidden" ></el-input>-->
<!--        <el-input v-model="datas[4][datas[4].name]" type="hidden" ></el-input>-->


<!--        <el-input v-model="form.A0010011" type="hidden" ></el-input>-->
<!--        <el-input v-model="form.A0010012" type="hidden" ></el-input>-->
<!--        <el-input v-model="form.A0010013" type="hidden" ></el-input>-->
<!--        <el-input v-model="form.A0010014" type="hidden" ></el-input>-->
<!--        <el-input v-model="form.cusId" type="hidden"></el-input>-->
<!--        <el-input v-model="form.dataSetId" type="hidden"></el-input>-->
      </el-form-item>
    </el-form-item>
  </el-form>
    </div>
    </center>
  </div>
</template>

<script>
import axios from 'axios'
import { uuid } from 'vue-uuid';
export default {
  data() {
    return {
      form: {
        reportName:'',
        reportEnName:'',
        reportChEnName:'',
        remarks:'',
        code:'',
        isPublic:'1',
        isPrinting:"1",
        isExport:"1",

        datas:[{},{},{},{}],
        A0010011:'',
        A0010012:'',
        A0010013:'',
        A0010014:'',



      },
      // uuid1:'',
      // cusList:{},
      uploadUrl: 'file/upload',
      fileList: [],


    }
  },
  created() {

    console.log("上个页面传来的是",sessionStorage)
    console.log("上个页面传来的是",this.$route.params)
    // this.handleUUIDv1()
    this.form.code = this.$uuid.v1()
    console.log("页面刷新后新产生的uuid是",this.form.code)

    // let sessionData = JSON.parse(sessionStorage.getItem("sessionData"));
    // console.log("接到的值是",sessionData);
    // this.datas[0][sessionData[1].name] = sessionData[1].data;
    // this.datas[1][sessionData[2].name] = sessionData[2].data;
    // this.datas[2][sessionData[3].name] = sessionData[3].data;
    // this.datas[3][sessionData[4].name] = sessionData[4].data;
    // // this.datas[0].name = sessionData[1].name;
    // this.datas[1].name = sessionData[2].name;
    // this.datas[2].name = sessionData[3].name;
    // this.datas[3].name = sessionData[4].name;

    // this.form.A0010011 = sessionStorage.getItem("A0010011")
    // this.form.A0010012 = sessionStorage.getItem("A0010012")
    // this.form.A0010013 = sessionStorage.getItem("A0010013")
    // this.form.A0010014 = sessionStorage.getItem("A0010014")
    //
    // this.form.cusId = sessionStorage.getItem("cusId")
    // this.form.dataSetId = sessionStorage.getItem("dataSetId")
  },
  watch:{
    reportName: function (newVal,oldVal) {//新值和原值

      console.log("name改变了 a:"+newVal+"    b:"+oldVal)

    }
  },
  methods: {



    //使用uuid
    // handleUUIDv1() {
    //   this.uuid1 = this.$uuid.v1()
    // },
    //点击多选按钮true和false变成1或者2
    reset(form){
      this.$refs['form'].resetFields();
    },
    //获取上个页面传来的数据
    getcustomQuery() {

      let reportName=this.form.reportName
      sessionStorage.setItem("reportName",reportName)
      let reportEnName = this.form.reportEnName
      sessionStorage.setItem("reportEnName",reportEnName)
      let reportChEnName = this.form.reportChEnName
      sessionStorage.setItem("reportChEnName",reportChEnName)
      let remarks = this.form.remarks
      sessionStorage.setItem("remarks",remarks)
      let code = this.form.code
      sessionStorage.setItem("code",code)
      let isPublic = this.form.isPublic
      sessionStorage.setItem("isPublic",isPublic)
      let isPrinting = this.form.isPrinting
      sessionStorage.setItem("isPrinting",isPrinting)
      let isExport = this.form.isExport
      sessionStorage.setItem("isExport",isExport)



      console.log("上个页面传来的是",sessionStorage)
    },
    // this.$router.push('/reportTools/cusMain'),点击保存发送链接 并跳转
    tocustomQuery(){
      this.$router.push({
        name:'customQuery',
        params:{
          datasetId:this.$route.params.datasetId,
          targetObj:this.$route.params.targetObj,
          renderData1:this.$route.params.renderData1,
          renderData2:this.$route.params.renderData2,
          renderData3:this.$route.params.renderData3,
          renderData4:this.$route.params.renderData4,
        }
      })
    },

    saveResource(){
      console.log("当前页面表单的数据",this.form)
      // sessionStorage.setItem("params",JSON.stringify(this.form))
      console.log("sessionStorage中的数据",sessionStorage)
      this.getcustomQuery()
      this.$http.post("/reporttools/report-show/addReportShow",sessionStorage).then(
        resp=>{
        console.log(resp)
          this.$router.push('/reportTools/cusMain')
      })
    },

    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    handleUploadError(error, file) {
      console.log("文件上传出错："+error)
    },
    //测试上传文件(注意web的上下文)
    handleBeforeUpload(file){
      console.log("开始上传，上传的文件为："+file)
      let formData = new FormData();
      formData.append("multipartFiles", file);
      axios({
        method: 'post',
        url: 'file/upload',
        data: formData,
        headers: {'Content-Type': 'multipart/form-data' }
      }).then((res) => {
        console.log("文件上传返回："+res)
      }).catch(error => {
        console.log("文件上传异常:"+error)
      })
    },

  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/reportTools/basicMessageSet.vue